import styled from 'styled-components';
import { Common } from '@stockbit/ui';
import { Button } from 'antd';

const { TelephoneInput: PhoneInput } = Common;

export const TelephoneInput = styled(PhoneInput)`
  input[type='tel'] {
    font-family: var(--regular-font);
    font-weight: 500;
    font-size: 16px;
    border: solid 1px #dadada;
    border-radius: 2px;
  }

  .flag-dropdown {
    border: none;
  }
`;

export const OtpMethodSubmit = styled(Button)`
  height: auto;
  padding: 12.5px;
  width: 100%;
  border-radius: 4px;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;

  &:disabled {
    color: #ffffff;
  }
`;
